import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InstOption from '../../../../utils/InstOption';
import { OptionTransparentIcon } from '../../../../utils/SVGIcon';
import { GetSearchParams, mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TabButton({ title, name, active, onClick }) {
    return (
        <button
            type="button"
            onClick={() => onClick(name?.toLowerCase())}
            className={cn(
                `group h-full w-full md:w-auto md:min-w-20 flex justify-center items-center gap-2.5 bg-transparent text-secondary hover:bg-secondary hover:text-white font-medium text-xl focus:outline-none outline-none transition-colors cursor-pointer rounded-md px-3 py-2`,
                {
                    'active bg-secondary text-white': active
                }
            )}
        >
            <span className="inline-block capitalize whitespace-nowrap">{title || name}</span>
        </button>
    );
}

function ServiceTableTab({ data, onActionClick }) {
    const navigate = useNavigate();
    const tabName = GetSearchParams('tab') || 'invoices';
    const [activeTab, setActiveTab] = useState(tabName);
    const [showMenu, setShowMenu] = useState(false);

    const tabArr = [
        {
            id: 'invoices',
            title: 'Invoices'
        },
        {
            id: 'payments',
            title: 'Payments'
        },
        {
            id: 'activity',
            title: 'Activity'
        }
    ];

    const handleSetTab = (tab) => {
        setActiveTab(tab);
        navigate(
            mkRelativeUrl(`/services/manage/${data?.id}/info/`, {
                tab
            })
        );
    };

    const handleActionClick = (action) => {
        setShowMenu(false);
        if (onActionClick) {
            onActionClick(action);
        }
    };

    return (
        <div className="flex items-center justify-between gap-4 mb-7">
            <div>
                <div
                    className={cn(
                        'h-13 p-[5px] flex sm:inline-flex flex-nowrap justify-start items-center gap-[5px] bg-secondary-100 rounded-10 overflow-auto md:overflow-hidden custom-scrollbar scroll-h-sm flex-1',
                        {
                            'placeholder-mode': data?.demo
                        }
                    )}
                >
                    {tabArr.map((item) => (
                        <TabButton
                            key={item?.id}
                            title={item?.title}
                            name={item?.id}
                            active={activeTab === item?.id}
                            onClick={handleSetTab}
                        />
                    ))}
                </div>
            </div>

            {/* Action Dropdown */}
            <div className="relative">
                <button
                    type="button"
                    onClick={() => setShowMenu(!showMenu)}
                    className="h-13 min-w-[52px] p-3 flex justify-center items-center bg-secondary text-white hover:bg-secondary-700 rounded-10 transition-colors"
                >
                    <OptionTransparentIcon />
                </button>
                <InstOption showMenu={showMenu} setShowMenu={setShowMenu} className="right-0">
                    {data?.status === 'initiate' && (
                        <button type="button" onClick={() => handleActionClick('make-implement')}>
                            Make Implement
                        </button>
                    )}
                    {data?.status === 'implement' && (
                        <button type="button" onClick={() => handleActionClick('make-ongoing')}>
                            Make Ongoing
                        </button>
                    )}
                    {data?.status !== 'completed' && (
                        <button type="button" onClick={() => handleActionClick('make-done')}>
                            Make Done
                        </button>
                    )}
                    <button type="button" onClick={() => handleActionClick('make-iteration')}>
                        Make Iteration
                    </button>
                    <button type="button" onClick={() => handleActionClick('renew-service')}>
                        Renew Service
                    </button>
                    <button
                        type="button"
                        onClick={() => handleActionClick('create-support-ticket')}
                    >
                        Create Support Ticket
                    </button>
                </InstOption>
            </div>
        </div>
    );
}

export default ServiceTableTab;
